import { Component, OnInit, Inject, ViewChild, ElementRef } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { HttpClient } from '@angular/common/http';
import { PdfMakeWrapper } from 'pdfmake-wrapper';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import Utils from 'src/app/utils/utils';

@Component({
  selector: 'app-modal-mensagem',
  templateUrl: './modal-mensagem.component.html',
  styleUrls: ['./modal-mensagem.component.css']
})
export class ModalMensagemComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<ModalMensagemComponent>,
    private http: HttpClient,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  @ViewChild('dadosRegistro') myDiv: ElementRef;

  innerHtml: string;
  pulaLinha = '\r\n';

  ngOnInit() {
    this.innerHtml = this.setarDadosTela();
  }

  onClose() {
    this.dialogRef.close();
  }


  setarDadosTela() {
    if (this.data.dadosRegistro.situacao === 3) {
      return this.mensagemNaoAutorizado();
    } else if (this.data.dadosRegistro.situacao === 4) {
      return this.mensagemRevogado();
    } else if (this.data.dadosRegistro.situacao === 1) {
      return this.mensagemPreAutorizado();
    }

  }

  mensagemNaoAutorizado() {
    const msg = "Acusamos a NÃO AUTORIZAÇÃO do registro anterior. "
    .concat("<p><p>")
    .concat("Para acessar o Conectividade Social e suas funcionalidades é necessário estar registrado.")
    .concat("<p><p>")
    .concat("Se desejar realizar um novo registro agora, clique no botão 'OK'.");
    return msg;
  }

  mensagemRevogado() {
    const msg = "Acusamos a REVOGAÇÃO do registro anterior. "
      .concat("<p><p>")
      .concat("Para acessar o Conectividade Social e suas funcionalidades é necessário estar registrado.")
      .concat("<p><p>")
      .concat("Se desejar realizar um novo registro agora, clique no botão 'OK'.");
    return msg;
  }

  mensagemPreAutorizado() {
    const msg = 'Identificamos que o certificado possui pré registro aguardando autorização. Para renovação do registro clique em "OK". '
    return msg;
  }

  get titulo() {
    return this.data.titulo;
  }

}
